<template lang="pug">
.z-100.auto-alpha-0.group(:class="[isEditModeActive ? 'auto-alpha-1' : '']")
  label.absolute.top-12.inline-block.text-sm.dark_text-white.select-none.py-2.px-4.w-80.rounded-full.flex.items-center.gap-3.group(
    :class="[hasDelete ? 'right-60' : 'right-52', 'dark_bg-black/70 bg-white/70']"
    ref="elRef"
  )
    span.transition(:class="isDescriptionPresentForACurrentTag ? 'opacity-20' : 'opacity-80'") 
      uc-icon.mx-1(icon="mage:globe-fill") 
      span Universal content
    span.opacity-80.transition | 
    span.transition(:class="isDescriptionPresentForACurrentTag ? 'opacity-80' : 'opacity-20'") 
      uc-icon.mr-1(icon="mdi:stars")
      span Dynamic content
  .tooltip.prose.bg-gray-600.text-white.rounded-sm.shadow-lg.py-2.px-4.absolute.top-24.right-52.transition.auto-alpha-0.group-hover_auto-alpha-1.w-80
    p.text-sm(v-if="!isDescriptionPresentForACurrentTag") 
      span This screen is shown in all versions of the course. Its content 
      span.italic does not change 
      span based on what the user chooses in the builder.
    div(v-else)
      p.text-sm This screen is shown depending on the user choosing the following in the builder:
      ul.text-sm.italic.list-disc.list-inside
        li(v-for="tag in currentTags" :key="tag") {{ tagDescription(tag) }}
</template>

<script setup lang="ts">
import { computed, inject, ref, unref } from 'vue';
import getTags, { tagDescription } from '../lib/getTags';

const currentLocation = unref(inject('currentLocation'));
const isEditModeActive = inject('isEditModeActive') as Ref<boolean>;
const props = defineProps<{
  screen: UcScreen;
  unit: Page;
  type: string;
  id: string;
  hasDelete?: boolean;
}>();
const elRef = ref<HTMLElement>();

const currentScreenTags = computed(() => {
  return getTags(props.screen);
});

const currentUnitTags = computed(() => {
  return getTags(props.unit);
});

const currentTags = computed(() => {
  // Combine screen and unit tags while filtering out any that don't have a description and remove duplicates
  return [...currentScreenTags.value, ...currentUnitTags.value]
    .filter(tag => tagDescription(tag))
    .filter((tag, index, self) => self.indexOf(tag) === index);
});

const isDescriptionPresentForACurrentTag = computed(() => {
  return currentTags.value.some(tag => tagDescription(tag));
});
</script>

<style scoped>
.tooltip::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #52525b;
}

.prose :where(ul):not(:where([class~='not-prose'] *)) {
  padding-left: 0 !important;
}
</style>
